<!--拼团详情-->
<template>
  <div>
    <van-swipe class="header-swiper" :autoplay="3000" indicator-color="FD2840">
      <van-swipe-item v-for="item in detail.pics_url" :key="item.id">
        <img :src="item" alt v-lazy="item" /> 
      </van-swipe-item>
    </van-swipe>
    <div class="flex-between">
      <div class="flex-bleft">
        <span class="tuan-text">团购价</span>
        <span class="tuan-price">¥{{detail.price}}</span>
        <span class="thr-price">¥{{detail.goods_price}}</span>
      </div>
      <div class="flex-bright">
        <div class="djs-text" v-if="detail.status == 1">距离结束还有</div>
        <div class="djs-text" v-else-if="detail.status == 3">距离开始还有</div>
        <div class="djs-text" v-else-if="detail.status == 4">已过期</div>
        <div class="djs-text" v-else-if="detail.status == 2">已下架</div>
        <div class="djs-num">
          <van-count-down :time="(detail.last_time + 1)* 1000">
            <template v-slot="timeData">
              <span class="item">{{ timeData.days }}</span>天
              <span class="item">{{ timeData.hours }}</span>
              <span class="sign">:</span>
              <span class="item">{{ timeData.minutes }}</span>
              <span class="sign">:</span>
              <span class="item">{{ timeData.seconds }}</span>
            </template>
          </van-count-down>
        </div>
      </div>
    </div>
    <div class="good-name">{{detail.title}}</div>
    <div class="row-yf gray">
      <div class="row-left">已售 {{detail.sold_count + detail.sold_show_count}}</div>
      <div class="row-right-yf">
        运费 ¥
        <span
          v-if="detail.express_price[0] == detail.express_price[1]"
        >{{detail.express_price[0]}}</span>
        <span v-else>{{detail.express_price[0] +'-'+ detail.express_price[1]}}</span>
      </div>
    </div>
    <div class="flex-between dian-raw" @click="goBaseDetail(detail.business_id)">
      <div class="dian-left">
        <img :src="detail.business_pic_url" alt />
        <div class="shop-text">
          <div class="shop-name">{{detail.business_name}}</div>
          <div class="shop-det gray">{{detail.business_desc}}</div>
        </div>
      </div>
      <div class="dian-right">
        去逛逛
        <img class="icon-right-tip" src="../../../assets/images/icon-right.png" alt />
      </div>
    </div>

    <div class="row-list app-border-top">
      <div class="app-border-bottom flex-between row-one" v-for="(item,index) in detail.extra_data">
        <span>{{item.name}}</span>
        <span>{{item.value}}</span>
      </div>
    </div>
    <div class="tuan-rule-box border-top">
      <div class="flex-between tuan-rule-head">
        <div class="tuan-rule-text">拼团规则</div>
        <!--<div class="tuan-rule-detail gray-light">
            详细规则<img class="icon-right" src="../../../assets/images/icon-right.png" alt="">
        </div>-->
      </div>
      <div class="tuan-nav gray-light">
        <div class="tuan-nav-imgo">
          <div class="tuan-img-box">
            <img src="../../../assets/newImg/icon-tuan-step-1.png" alt />
          </div>
          <p>发起或者参团</p>
        </div>
        <div class="tuan-nav-imgt">
          <div class="tuan-img-box">
            <img src="../../../assets/newImg/icon-tuan-step-2.png" alt />
          </div>
          <p>邀请好友参团</p>
        </div>
        <div class="tuan-nav-imgth">
          <div class="tuan-img-box">
            <img src="../../../assets/newImg/icon-jielong-step-4.png" alt />
          </div>
          <p>人满成团</p>
        </div>
      </div>
    </div>
    <div class="tuan-rule-box border-top" v-if="tuan_order_list.length>0 &&detail.show_info == 1">
      <div class="flex-between tuan-rule-join">
        <div class="tuan-rule-text">有{{tuan_order_list.length}}人正在开团，可直接参与</div>
      </div>

      <div
        class="tuan-user flex-between"
        v-for="(item, index) in tuan_order_list"
        @click="gotuanShare(item.order_id)"
      >
        <div class="tuan-user-left">
          <img :src="item.user_head" alt />
          <div class="tuan-user-name">{{item.user_name}}</div>
        </div>
        <div class="tuan-user-right">
          <div class="tuan-time-box">
            <div class="tuan-time-tip">
              还差
              <span>{{item.last_member_count}}</span>人成团
            </div>
            <van-count-down :time="(item.last_time+1)*1000" format="剩余DD天 HH : mm : ss" />
          </div>
          <div class="join-tuan">去参团</div>
        </div>
      </div>
    </div>

    <div class="tuan-rule-box border-top" v-if="false">
      <div class="flex-between tuan-rule-head">
        <div class="tuan-rule-text">温馨提示</div>
        <div class="tuan-rule-detail gray-light">
          <img class="icon-right" src="../../../assets/images/icon-right.png" alt />
        </div>
      </div>
      <div class="tips-text">
        <div>有效期：2019-01-18至2019-12-31</div>
        <div>除外日期：春节、圣诞节不可用</div>
        <div>使用时间：周一至周日 24小时可用</div>
        <div>规则提醒：需您当日一次性体验完毕所有项目，不再与其他优惠同享</div>
      </div>
    </div>
    <div class="detail-title">
      <div></div>
      <span>商品详情</span>
      <div></div>
    </div>
    <!--		<div class="detail-img"><img src="../../../assets/newImg/WechatIMG941.png" alt=""></div>-->
    <div class="detail-img" v-html="detail.content"></div>
    <div style="height: 50px;"></div>
    <div class="footer">
      <div class="footer-home" @click="goHome">
        <van-icon name="home-o" />
        <p>首页</p>
      </div>
      <div class="footer-kf" @click="goMine">
        <img src="../../../assets/newImg/gMy.png" alt />
        <p>我的</p>
      </div>
      <div class="footer-one" @click="goodsSkuSelect">
        <p class="footer-one-pri">¥{{detail.goods_price}}</p>
        <p>单独购买</p>
      </div>
      <div class="footer-tuan" @click="skuSelect">
        <p class="footer-tuna-pri">¥{{detail.price}}</p>
        <p>{{detail.complete_count}}人成团</p>
      </div>
    </div>

    <!-- 基础用法 -->
    <div class="sku-container">
      <van-sku
        v-model="showGoodsSkuPicker"
        :sku="skuData.goods_sku"
        :goods="skuData.goods"
        :goods-id="skuData.goods_id"
        :hide-stock="skuData.hide_stock"
        :close-on-click-overlay="closeOnClickOverlay"
        :message-config="messageConfig"
        @buy-clicked="toGoodsBuy"
      >
        <template slot="sku-actions" slot-scope="props">
          <div class="van-sku-actions">
            <van-button square size="large" type="warning">积分兑换</van-button>
            <!-- 直接触发 sku 内部事件，通过内部事件执行 onBuyClicked 回调 -->
            <van-button
              square
              size="large"
              type="warning"
              @click="props.skuEventBus.$emit('sku:buy')"
            >立即购买</van-button>
          </div>
        </template>
      </van-sku>
    </div>

    <div class="sku-container">
      <van-sku
        v-model="showSkuPicker"
        :sku="skuData.sku"
        :goods="skuData.goods"
        :goods-id="skuData.goods_id"
        :hide-stock="skuData.hide_stock"
        :close-on-click-overlay="closeOnClickOverlay"
        :message-config="messageConfig"
        @buy-clicked="toBuy"
      >
        <template slot="sku-actions" slot-scope="props">
          <div class="van-sku-actions">
            <van-button square size="large" type="warning">积分兑换</van-button>
            <!-- 直接触发 sku 内部事件，通过内部事件执行 onBuyClicked 回调 -->
            <van-button
              square
              size="large"
              type="warning"
              @click="props.skuEventBus.$emit('sku:buy')"
            >立即购买</van-button>
          </div>
        </template>
      </van-sku>
    </div>
    <div class="shareShow" v-if="showWxShare" @click="onShareCancel">
      <div>
        <h2>点击分享给好友</h2>
      </div>
    </div>
  </div>
</template>
<style scoped>
.shareShow {
  position: fixed;
  text-align: center;
  width: 100%;
  height: 100%;
  z-index: 10000;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.68);
  color: rgb(255, 255, 255);
}

.shareShow div {
  background: url(https://static.dierqudao.com/images/cheesemanv2.0/icon_share_arrow.png)
    no-repeat right top;
  height: 100%;
  background-size: 100px;
  padding: 180px 0 0 0;
  margin: 10px;
  line-height: 40px;
}

.shareShow h2 {
  /*font-size: 1.8rem*/
  font-size: 0.8rem;
}

.van-count-down {
  display: flex;
  justify-content: center;
  line-height: 17px;
}

.van-icon-home-o {
  color: #7d7e80;
  font-size: 20px;
}

.van-sku-actions button:first-child {
  display: none !important;
}

.icon-right-tip {
  width: 16px;
  height: 16px;
}

.row-list {
  color: #181818;
  font-size: 12px;
  padding: 0 15.5px;
}

.row-one {
  padding: 15.5px 0;
}

.app-border-bottom {
  border-bottom: 1px solid #efefef;
}

.border-top {
  border-top: 0.1rem solid #efefef;
}

.header-swiper {
  height: 5.25rem;
}

.header-swiper img {
  width: 100%;
  height: 5.25rem;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-bleft {
  width: 5.07rem;
  height: 0.9rem;
  line-height: 0.9rem;
  background: rgba(253, 40, 64, 1);
  color: #fff;
  font-size: 10px;
}

.flex-bright {
  width: 2.43rem;
  height: 0.9rem;
  background: rgba(255, 232, 163, 1);
  text-align: center;
}

.tuan-text {
  padding: 2px;
  background: #fff;
  color: #fd2840;
  border-radius: 3px;
  margin: 0 0.1rem 0 0.32rem;
}

.tuan-price {
  font-size: 16px;
  margin-right: 0.1rem;
}

.thr-price {
  text-decoration: line-through;
}

.shop-det {
  width: 240px;
}

.djs-text {
  font-size: 11px;
  color: #695a39;
  margin-top: 0.1rem;
}

.djs-num {
  font-size: 10px;
}

.djs-num >>> span.item {
  font-size: 14px;
  background: #000000;
  color: #fff;
  display: block;
  width: 17px;
  height: 17px;
}

.djs-num >>> span.sign {
  display: block;
  width: 10px;
  height: 10px;
  font-weight: 700;
}

.good-name {
  font-size: 15px;
  padding: 0.3rem 0.13rem;
}

.row-yf {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  padding: 0.2rem 0.3rem;
  border-bottom: 1px solid #efefef;
}

.price-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.nomarl-price {
  font-size: 16px;
  color: #fd2840;
  margin-right: 0.1rem;
}

.nomarl-price span {
  font-size: 12px;
}

.thr-big-price {
  font-size: 12px;
  text-decoration: line-through;
}

.hav-money {
  font-size: 12px;
  color: #fd2840;
  background: rgba(253, 232, 234, 1);
  padding: 2px 5px;
  text-align: center;
}

.earnings {
  text-align: right;
}

.sell-num {
  font-size: 12px;
}

.sell-num::after {
  border: none;
}

.astrict-text {
  font-size: 12px;
  display: flex;
  justify-content: flex-start;
  margin: 0 0.3rem;
  padding: 0.3rem 0;
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
}

.astrict-text img {
  width: 16px;
  height: 16px;
  margin-right: 0.1rem;
}

.dian-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.dian-raw {
  padding: 0.2rem 0.3rem 0.2rem 0.2rem;
}

.dian-left img {
  width: 0.88rem;
  height: 0.88rem;
  border-radius: 100%;
  margin-right: 0.1rem;
}

.dian-name {
  font-size: 13px;
}

.dian-detail {
  font-size: 11px;
}

.dian-right {
  font-size: 12px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.qun-left img {
  border-radius: 0;
}

.tuan-rule-box {
  padding: 0 0.3rem;
}

.tuan-rule-text {
  font-size: 13px;
}

.tuan-rule-detail {
  font-size: 12px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.tuan-rule-head {
  padding: 0.3rem 0;
  border-bottom: 1px solid #efefef;
}

.tuan-nav {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.4rem 0;
  font-size: 12px;
}

.tuan-nav > div {
  flex: 1;
}

.tuan-nav p {
  width: 100%;
}

.tuan-nav-imgo img {
  width: 0.8rem;
  height: 0.74rem;
}

.tuan-nav-imgt img {
  width: 0.6rem;
  height: 0.58rem;
}

.tuan-nav-imgth img {
  width: 0.6rem;
  height: 0.58rem;
}

.tuan-nav-imgt {
  text-align: center;
}

.tuan-nav-imgt .tuan-img-box {
  margin: 0 auto;
}

.tuan-nav-imgth {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  padding-right: 0.3rem;
}

.tuan-nav-imgth p {
  text-align: right;
}

.tuan-img-box {
  width: 0.8rem;
  height: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tuan-user {
  padding: 0.2rem 0;
  font-size: 13px;
  border-top: 1px solid #efefef;
}

.tuan-rule-join {
  padding: 0.3rem;
}

.tuan-user-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.tuan-user-left img {
  width: 0.78rem;
  height: 0.78rem;
  border-radius: 100%;
  margin-right: 0.2rem;
}

.tuan-user-name {
  max-width: 1.8rem;
}

.tuan-user-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.tuan-time-box {
  /*margin-right: 10px;*/
  text-align: right;
}

.tuan-time-tip span {
  color: #fd2840;
}

.join-tuan {
  font-size: 12px;
  background: #fde8ea;
  border-radius: 3px;
  padding: 2px 10px;
  margin-left: 0.2rem;
  height: 24px;
  line-height: 24px;
}

.tips-text {
  color: #444444;
  font-size: 13px;
  line-height: 0.5rem;
  padding: 0.2rem 0;
}

.detail-title {
  width: 7.5rem;
  line-height: 0.5rem;
  height: 0.5rem;
  background: rgba(239, 239, 239, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.detail-title div {
  width: 0.62rem;
  height: 1px;
  background: rgba(0, 0, 0, 1);
  opacity: 0.08;
}

.detail-title span {
  margin: 0 0.2rem;
}

.detail-img >>> img {
  width: 100%;
  /*margin-bottom: 50px;*/
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 47px;
  font-size: 11px;
  color: #6c6c6c;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  border-top: 1px solid #efefef;
  background: #fff;
}

.footer > div {
  height: 100%;
  padding-top: 0.1rem;
  box-sizing: border-box;
}

.footer-home {
  width: 1.36rem;
  border-right: 1px solid #efefef;
}

.footer-home img {
  width: 20px;
  height: 20px;
}

.footer-kf {
  width: 1.24rem;
  border-right: 1px solid #efefef;
}

.footer-kf img {
  width: 20px;
  height: 20px;
}

.footer-one {
  width: 2.22rem;
  color: #000000;
  line-height: 21px;
}

.footer-one-pri {
  font-size: 14px;
  font-weight: bolder;
}

.footer-tuan {
  width: 2.66rem;
  background: #fd2840;
  color: #fff;
  line-height: 21px;
}

.footer-tuna-pri {
  font-size: 14px;
}
</style>

<script>
import Vue from "vue";
import {
  Swipe,
  SwipeItem,
  Cell,
  CellGroup,
  Sku,
  Notify,
  Icon,
  CountDown
} from "vant";
import LoginDialog from "@/components/LoginDialog.vue";

Vue.use(Swipe)
  .use(SwipeItem)
  .use(Cell)
  .use(CellGroup)
  .use(Sku)
  .use(Notify)
  .use(Icon)
  .use(CountDown);

export default {
  name: "TuanDetail",
  components: {
    LoginDialog
  },
  data: function() {
    return {
      skuData: {
        sku: {
          none_sku: false, // 是否无规格商品
          hide_stock: false, // 是否隐藏剩余库存
          list: [],
          tree: []
        },
        goods_sku: {
          none_sku: false, // 是否无规格商品
          hide_stock: false, // 是否隐藏剩余库存
          list: [],
          tree: []
        },
        goods: {},
        goods_id: 0
      },
      detail: {
        id: 0,
        title: "-",
        pic_url: "",
        pics_url: [],
        extra_data: [],
        content: [],
        price_range: "-",
        orig_price: "-",
        sold_count: 0,
        sold_show_count: 0,
        views_count: 0,
        views_show_count: 0,
        express_price: "-",
        business_name: "",
        business_pic_url: "",
        business_desc: "",
        business_id: 0
      },

      showGoodsSkuPicker: false,
      showSkuPicker: false,
      closeOnClickOverlay: true,
      showWxShare: false,
      messageConfig: {},

      duration: 300,
      tuan_order_list: [],

      timeData: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0
      }
    };
  },
  filter: {},
  mounted() {
    document.title = "拼团详情";
    this.getTuanDetail();

    let href = window.location.href.split("#");
    if (href[1] == "share") {
      this.showWxShare = true;
    }
  },
  destroyed() {},
  methods: {
    getTuanDetail() {
      let id = this.$route.query.id;
      let that = this;
      let sku = {};
      let total = 0;

      this.$api.get("/api/tuan/detail", { id: id }, res => {
        that.detail = res.data.data;
        that.share = res.data.share;
        that.tuan_order_list = res.data.tuan_order_list;

        that.skuData.sku = sku = res.data.sku;
        that.skuData.sku.messages = [];

        that.skuData.goods = {
          title: that.detail.title,
          picture: that.detail.pic_url
        };

        that.wxShare(
          res.data.share.title,
          res.data.share.desc,
          res.data.share.url,
          res.data.share.pic_url
        );

        // 总数量
        for (let i = 0; i < sku.list.length; i++) {
          total = total + sku.list[i].stock_num;
        }

        that.skuData.sku.stock_num = total;
        that.skuData.sku.price = that.detail.price / 100;
        that.skuData.goods_id = that.detail.goods_id;

        that.skuData.goods_sku = res.data.goods_sku;
        that.skuData.goods_sku.messages = [];
        that.skuData.goods_sku.stock_num = total;
        that.skuData.goods_sku.price = that.detail.goods_price / 100;

        that.lastTimeRun();
        that.checkStatus();
      });
    },

    onShareCancel() {
      this.showWxShare = false;
    },

    lastTimeRun() {
      let that = this;
      let lastTime_t_handle = setInterval(() => {
        that.timeData = that.lastTime(that.detail.last_time);

        if (that.detail.last_time == 0) {
          clearInterval(lastTime_t_handle);
          return;
        }
        that.detail.last_time -= 1;
      }, 1000);
    },

    checkStatus() {
      let that = this;
      if (that.detail.status == 0) {
        Notify({
          message: "活动不存在",
          duration: 5000
        });
        return false;
      } else if (that.detail.status == 2) {
        Notify({
          message: "活动已取消",
          duration: 5000
        });
        return false;
      } else if (that.detail.status == 3) {
        Notify({
          message: "活动未开始",
          duration: 5000
        });
        return false;
      } else if (that.detail.status == 4) {
        Notify({
          message: "活动已过期",
          duration: 5000
        });
        return false;
      }
      return true;
    },

    goodsSkuSelect() {
      let that = this;
      if (!that.checkStatus()) {
        return;
      }

      that.showGoodsSkuPicker = true;
    },

    skuSelect() {
      let that = this;

      if (!that.checkStatus()) {
        return;
      }

      that.showSkuPicker = true;
    },

    // 立即购买
    toBuy(data) {
      let that = this;

      // console.log(data);return
      let goods_items = [
        {
          goods_id: data.goodsId,
          sku_id: data.selectedSkuComb.id,
          count: data.selectedNum
        }
      ];

      // 存入缓存
      localStorage.setItem(
        "tuan_order_check_goods_items",
        JSON.stringify(goods_items)
      );
      localStorage.setItem("tuan_order_id", 0);

      let url = "/tuanordercheck";
      if (that.detail.goods_type == "shop") {
        url = "/shoptuanordercheck";
      }

      console.log(url);
      this.$router.push({
        path: url
      });
    },

    toGoodsBuy(data) {
      let that = this;

      let goods_items = [
        {
          goods_id: data.goodsId,
          sku_id: data.selectedSkuComb.id,
          count: data.selectedNum
        }
      ];

      // 存入缓存
      localStorage.setItem(
        "order_check_goods_items",
        JSON.stringify(goods_items)
      );

      let url = "/ordercheck";
      if (that.detail.goods_type == "shop") {
        url = "/shopordercheck";
      }

      this.$router.push({
        path: url
      });
    },

    goBaseDetail(id) {
      console.log(id);
      this.$router.push({
        path: "/basedetail",
        query: {
          id: id
        }
      });
    },

    gotuanShare(id) {
      this.$router.push({
        path: "/tuanshare",
        query: {
          id: id
        }
      });
    },

    goMine() {
      this.$router.push({
        path: "mineindex"
      });
    },
    goHome() {
      rbLink({
        name: "GoodsIndex",
        query: { business_id: this.detail.business_id }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// TuanDetail.vue?02b7defe